/**
 * ローディングスピナーコンポーネント
 */
const LoadingSpinner = ({ message = '読み込み中...' }) => {
  return (
    <div className="loading-spinner">
      <span>{message}</span>
    </div>
  );
};

export default LoadingSpinner;
